import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { BaseEntityService } from './base-entity';
import { StorageService } from './storage';

export interface RouteSegmentSummary {
  id: number;
  name: string;
  sequence: number;
}

export interface Route {
  id: number;
  route: string;
  lineIds: number[];
  segments?: RouteSegmentSummary[];
  defaultPricelistId?: number | null;
  defaultPricelistName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RouteService extends BaseEntityService<Route> {
  constructor(
    indexedDbService: StorageService<Route>,
    baseApi: BaseApiService
  ) {
    super(
      baseApi,
      indexedDbService,
      'RouteDatabase',  // IndexedDB database name
      'routes',         // Object store name
      'routes'          // API endpoint path
    );
  }
}
